import { Component } from '@angular/core';

@Component({
  selector: 'app-new-account-desktop-inactive-state',
  templateUrl: './new-account-desktop-inactive-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-desktop-inactive-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountDesktopInactiveStateComponent {}
